export enum DINE_CHECK_ANALYTICS {
    AVAIL_SUCCESS = 'DineCheckAvail_Success',
    NO_AVAIL = 'DineAvailResult_NoAvail'
};
export const DINE_ANALYTICS_LINK_ID = 'DineListing_SearchTimes';
export const EEC_STORAGE_KEY = 'dprd_storage_eec_calendar';
export const FIND_DINE_LIST_AVAILABILITY = 'findDineListAvailability';

